import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'react-bootstrap';
import HomeButton from './buttons/HomeButton'
import CurriculumVitaeButton from './buttons/CurriculumVitaeButton'
import WorksButton from './buttons/WorksButton'
import LegalAreasButton from './buttons/LegalAreasButton'

import location from '../static/images/location.jpeg'

class Contact extends Component {
    render() {
        let title;
        let text;
        switch(this.props.language){
            case 'English':
                title = 'Contact'
                text=
                    <div>
                        <h4>Attorney at Law</h4>
                        <h4>mr. sc. Zrinko Zrilić</h4>
                        <h4>Knezova S. Bribirskih 12</h4>
                        <h4>23000 Zadar, Croatia</h4>
                        <h4>Tel: 00385 23 213 802</h4>
                        <h4>Fax: 00385 23 224 373</h4>
                        <h4>Mob: 00385 98 272 420</h4>
                        <h4>E-mail: zrinko.zrilic@gmail.com</h4>
                    </div>
                break
            default:
                title = 'Kontakt'
                text=
                    <div>
                        <h4>Odvjetnik</h4>
                        <h4>mr. sc. Zrinko Zrilić</h4>
                        <h4>Knezova Š. Bribirskih 12</h4>
                        <h4>23000 Zadar, Hrvatska</h4>
                        <h4>Tel: 00385 23 213 802</h4>
                        <h4>Fax: 00385 23 224 373</h4>
                        <h4>Mob: 00385 98 272 420</h4>
                        <h4>E-mail: zrinko.zrilic@gmail.com</h4>
                    </div>
        }
        return (
            <div>
                <Row>
                    <HomeButton />
                    <CurriculumVitaeButton />
                    <WorksButton />
                    <LegalAreasButton />
                </Row>
                <br />
                <h2>{title}:</h2>
                <hr />
                <Row>
                    <Col md={3}>
                        {text}
                    </Col>
                    <Col md={9}>
                        <img src={location} className="bigPic" alt="And justice for all..." />
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
      language: state.language 
    };
  };

export default connect(mapStateToProps, null)(Contact);


// WEBPACK FOOTER //
// ./src/screens/Contact.js